var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    { staticClass: "page-title" },
    [
      _vm.icon
        ? _c("svg", { staticClass: "icon" }, [
            _c("use", { attrs: { "xlink:href": _vm.icon } })
          ])
        : _vm._e(),
      typeof _vm.title === "string"
        ? _c("span", [_vm._v(_vm._s(_vm.title))])
        : _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _vm._l(_vm.title, function(item, index) {
                return [
                  item.path && index !== _vm.title.length - 1
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          key: index,
                          class: item.path ? "" : "default",
                          attrs: { to: { path: item.path } }
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    : _c(
                        "el-breadcrumb-item",
                        {
                          key: index,
                          class: item.path && index ? "" : "default"
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                ]
              })
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bd5946f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bd5946f","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/PageTitle/index.vue
// module id = 838
// module chunks = 3 7 8 9 11 12 13 14 16 19 20 23 24 25 26 28 29